import React, { useState, useEffect, useRef, useCallback } from "react";
import Radio from "../common/input/radio";
import LoginForm from "./loginForm";
import HeaderNew from "../header/HeaderNew";
import '../../styles/common/header/_subHeader.css';
import {
    GetRequest,
    PostRequest,
    getIPAddress,
    getparamsString,
} from "../common/helper";
// import ReCAPTCHA from "react-google-recaptcha";
import { baseCss } from "../common/css";
import SignupForm from "./signupForm";
import Slider from "../common/login/slider";
import { apiUrl, captcha_key, countryCodeData } from "../common/constants";
import { renderImg } from "../common/icons/img";
import Bottom from "../common/fixedbar";
import Alert from "../common/alert";
import { isValidEmail } from "../common/input/ginput";
import Footer from "../footer/footer";
import LoginLoader from "../common/login/loginLoader";
import AlertTerms from "../common/login/alertTerms";
import SubHeader from "../header/subHeader";
import HeaderNonSrp from "../header/headerNonSrp";
import { stopTimer } from "../common/helper";
import { ACC_CRETN_SUCSS, CHNG_PWD, CMPLT_ACC_REG, ENT_OTP, LGN, PLZ_ENT_EML, PLZ_ENT_NM, PLZ_ENT_OTP, PLZ_ENT_PH, PLZ_ENT_PWD, PLZ_ENT_RE_CNFRM_PWD, PLZ_ENT_SAME_PWD, PWD_CHNGD_SUCSS, PWD_LNG_ERR, RE_CNFRM_PWD_LNG_ERR, SOR, VAL_EML_N_MOB, VYR, WRONG_OTP, PWD_NT_MATCH, RECAPTCHA_FAIL, RECAPTCHA_LOADING, t } from "../../translations/Login";
// import CaptchaV3 from "../common/recaptchav3";
import GoogleRecaptchaV3 from "../common/GoogleRecaptchaV3";


const LoginSignUp = () => {
    const [headText, setHeadText] = useState("Login");
    const [loginTab, setLoginTab] = useState(0);
    const [ipAddress, setIPAddress] = useState("");
    const [recaptchaValue, setRecaptchaValue] = useState("");
    const [email, setEmail] = useState("");
    const [cccode, setCcode] = useState("India +91");
    const [mobile, setMobile] = useState("");
    const [slider, setSlider] = useState(false);
    const [togglePassword, setTogglePassword] = useState(false);
    const [togglePasswordN, setTogglePasswordN] = useState(false);
    const [togglePasswordR, setTogglePasswordR] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordR, setPasswordR] = useState("");
    const [tncFlag, setTncFLag] = useState(false);
    const [resettingPassword, setResetting] = useState(false);

    const [loginTimer, setLoginTimer] = useState(false);
    const [signupTimer, setSignupTimer] = useState(false);

    const [resendLoginOTP, setResendLoginOTP] = useState("");
    const [resendSignupOTP, setResendSignupOTP] = useState("");

    const [loginOTP, setLoginOtp] = useState("");
    const [signupOTP, setSignupOtp] = useState("");
    const [blockError, setBlockError] = useState(false);
    const [countryCodeList, setCountryCodeList] = useState(countryCodeData);
    const [searchCountryCodeText, setSearchCountryCodeText] = useState("");
    const [checkedCountryCode, setCheckedCountryCode] = useState("+91");
    const [name, setName] = useState("");
    const [successmsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [buttonState, setButtonState] = useState(2);
    const [signupOtpSent, setsignupOtpSent] = useState(false);
    const [loader, setLoader] = useState(false);
    const [termsFlag, setTermsFlag] = useState(false);
    const [token, setToken] = useState("");
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const [validRecaptcha, setValidRecaptcha] = useState(0);
    const [confirmPassword, setConfirmPassword] = useState("");

    useEffect(() => {
        switch (buttonState) {
            case 0: {
                setHeadText(t(SOR));
                break;
            }
            case 1: {
                setHeadText(t(VYR));
                break;
            }
            case 2:
            case 3:
            case 4: {
                setHeadText(t(LGN));
                break;
            }
            default:
                break;
        }
    }, [buttonState]);
    useEffect(() => {
        if (loginTab === 0) {
            setButtonState(2);
        }
        if (loginTab === 1) {
            setButtonState(0);
        }
    }, [loginTab]);
    useEffect(() => {
        let timeoutId;

        if (blockError) {
            timeoutId = setTimeout(() => {
                setBlockError('');
            }, 3000);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, [blockError]);

    const getButtonText = () => {
        switch (buttonState) {
            case 0: {
                return t(VAL_EML_N_MOB);
            }
            case 1: {
                return t(CMPLT_ACC_REG);
            }
            case 2: {
                return t(LGN);
            }
            case 3: {
                return t(CHNG_PWD);
            }
            default:
                return t(CHNG_PWD);
        }
    };
    const goBack = () => {
        //this.props.history.goBack();
        //console.log("goBack");
        window.location.href = '/';
    };
    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };
    const prevsuccessmsg = usePrevious(successmsg);
    useEffect(() => {
        if (
            prevsuccessmsg === t(ACC_CRETN_SUCSS) ||
            prevsuccessmsg === t(PWD_CHNGD_SUCSS)
        ) {
            window.location.reload(true);
        }
    }, [successmsg]);
    useEffect(() => {
        stopTimer();
        getIPAddress()
            .then((ip) => {
                setIPAddress(ip);
            })
            .catch((error) => {
                // Handle error
                console.error("Error:", error);
            });
    }, []);
    const validateSignup = () => {

        if (!email || !isValidEmail(email)) {
            setErrorMsg(t(PLZ_ENT_EML));
            return false;
        }
        if (!name) {
            setErrorMsg(t(PLZ_ENT_NM));
            return false;
        }
        if (!mobile || mobile.length < 8) {
            setErrorMsg(t(PLZ_ENT_PH));
            return false;
        }
        if (!password) {
            setErrorMsg(t(PLZ_ENT_PWD));
            return false;
        }
        if (password && password.length < 6) {
            setErrorMsg(t(PWD_LNG_ERR));
            return false;
        }
        if (password !== confirmPassword) {
            setErrorMsg(t(PWD_NT_MATCH));
            return false;
        }
        // if (!passwordR || passwordR.length < 6) {
        //     setErrorMsg("Please Enter Reconfirm Password");
        //     return false;
        // }
        // if (password !== passwordR) {
        //     setErrorMsg("password and Reconfirm Password should be same");
        //     return false;
        // }
        if (!tncFlag) {
            setTermsFlag(true);
            // setErrorMsg(`Please agree to KSRTC's
            // Terms & Conditions and Privacy Policy`);
            return false;
        }
        return true;
    };
    const validateLogin = () => {
        if (!email || !isValidEmail(email)) {
            setErrorMsg(t(PLZ_ENT_EML));
            return false;
        }
        if (!mobile || mobile.length < 8) {
            setErrorMsg(t(PLZ_ENT_PH));
            return false;
        }
        if (!password) {
            setErrorMsg(t(PLZ_ENT_PWD));
            return false;
        }

        if (password && password.length < 6) {
            setErrorMsg(t(PWD_LNG_ERR));
            return false;
        }
        // if (!passwordR || passwordR.length < 6) {
        //     setErrorMsg("Please Enter Reconfirm Password");
        //     return false;
        // }
        // if (password !== passwordR) {
        //     setErrorMsg("password and Reconfirm Password should be same");
        //     return false;
        // }
        if (!tncFlag) {
            setTermsFlag(true);
            // setErrorMsg(`Please agree to KSRTC's
            // Terms & Conditions and Privacy Policy`);
            return false;
        }
        return true;
    };
    const validPasswordData = () => {

        if (!email || !isValidEmail(email)) {
            setErrorMsg(t(PLZ_ENT_EML));
            return false;
        }
        if (!mobile || mobile.length < 8) {
            setErrorMsg(t(PLZ_ENT_PH));
            return false;
        }
        if (!tncFlag) {
            setTermsFlag(true);
            // setErrorMsg(`Please agree to KSRTC's
            // Terms & Conditions and Privacy Policy`);
            return false;
        }
        return true;
    };
    const ValidNewPassowrdData = () => {

        if (!email || !isValidEmail(email)) {
            setErrorMsg(t(PLZ_ENT_EML));
            return false;
        }
        if (!mobile || mobile.length < 8) {
            setErrorMsg(t(PLZ_ENT_PH));
            return false;
        }
        if (!password) {
            setErrorMsg(t(PLZ_ENT_PWD));
            return false;
        }

        if (password && password.length < 6) {
            setErrorMsg(t(PWD_LNG_ERR));
            return false;
        }

        if (!passwordR) {
            setErrorMsg(t(PLZ_ENT_RE_CNFRM_PWD));
            return false;
        }

        if (passwordR && passwordR.length < 6) {
            setErrorMsg(t(RE_CNFRM_PWD_LNG_ERR));
            return false;
        }

        if (password !== passwordR) {
            setErrorMsg(t(PLZ_ENT_SAME_PWD));
            return false;
        }

        if (!loginOTP || loginOTP.length < 6) {
            setErrorMsg(t(ENT_OTP));
            return false;
        }
        if (!tncFlag) {
            setTermsFlag(true);
            // setErrorMsg(`Please agree to KSRTC's
            // Terms & Conditions and Privacy Policy`);
            return false;
        }
        return true;
    };
    const refreshCaptchaToken = () => {
        setRefreshReCaptcha((r) => !r);
    };

    const onVerify = useCallback((captchaToken) => {
        setToken(captchaToken);
    }, []);

    const verifyRecaptcha = async () => {
        if (!token) {
            return { Success: false, ErrorMessage: t(RECAPTCHA_LOADING) };
        }
        const data = {
            response: token,
        };
        setLoader(true);
        try {
            const res = await PostRequest(apiUrl.validateCaptcha, data);
            setLoader(false);
            return res || { Success: false, ErrorMessage: t(RECAPTCHA_FAIL) };
        } catch (err) {
            setLoader(false);
            return { Success: false, ErrorMessage: t(RECAPTCHA_FAIL) };
        }
    };

    const sendSignupOTP = async () => {
        setSignupTimer(false);
        if (!validateSignup()) {
            return;
        }

        const captchaRes = await verifyRecaptcha();
        refreshCaptchaToken();
        if (!captchaRes?.Success) {
            setErrorMsg(captchaRes?.ErrorMessage || t(RECAPTCHA_FAIL));
            return;
        }

        setLoader(true);
        let url = apiUrl.SendSignupOtp;
        const data = { userName: email, name: name, mobileNo: mobile };
        url = url + "?" + getparamsString(data);
        GetRequest(url)
            .then((res) => {
                if (res.Success === true) {
                    setsignupOtpSent(true);
                    setButtonState(1);
                    setSignupTimer(true);
                    setResendSignupOTP("disable");
                    setLoader(false);
                } else {
                    setLoader(false);
                    setBlockError(res.ErrorMessage);
                }
            })
            .catch((err) => { setLoader(false) });
    };
    const ValidateAndSIgnup = async () => {
        if (!signupOTP || signupOTP.length < 6) {
            setErrorMsg(t(ENT_OTP));
            return false;
        }
        if (!tncFlag) {
            setTermsFlag(true);
            // setErrorMsg(`Please agree to KSRTC's
            // Terms & Conditions and Privacy Policy`);
            return false;
        }

        const captchaRes = await verifyRecaptcha();
        refreshCaptchaToken();
        if (!captchaRes?.Success) {
            setErrorMsg(captchaRes?.ErrorMessage || t(RECAPTCHA_FAIL));
            return;
        }

        const data = {
            userName: email,
            name: name,
            mobileNo: mobile,
            password: password,
            otp: signupOTP,
            countryCode: "+91",
        };
        setLoader(true);
        PostRequest(apiUrl.APISignup, data)
            .then((res) => {
                if (res.Success) {
                    setLoader(false);
                    setSuccessMsg(t(ACC_CRETN_SUCSS));
                } else {
                    if (res.ErrorMessage === 'Invalid OTP !') {
                        setBlockError(t(WRONG_OTP))
                        setLoader(false);
                    } else {
                        setErrorMsg(res.ErrorMessage);
                        setLoader(false);
                    }
                }
            })
            .catch((err) => { setLoader(false); });
    };

    const validateAndLogin = async () => {
        let loginRedirectUrl = window.sessionStorage.getItem("afterLoginRedirectUrl");
        if (!validateLogin()) {
            return;
        }

        const captchaRes = await verifyRecaptcha();
        refreshCaptchaToken();
        if (!captchaRes?.Success) {
            setErrorMsg(captchaRes?.ErrorMessage || t(RECAPTCHA_FAIL));
            return;
        }

        const data = {
            userName: email,
            mobileNo: mobile,
            password: password,
            countryCode: "+91",
        };

        setLoader(true);
        PostRequest(apiUrl.userLogin, data)
            .then((res) => {
                if (res.Success) {
                    setLoader(false);
                    if (loginRedirectUrl) {
                        window.location.href = loginRedirectUrl;
                    } else {
                        window.location.replace("/");
                    }
                } else {
                    setLoader(false)
                    setErrorMsg(res.ErrorMessage);
                }
            })
            .catch((err) => { setLoader(false) });

    };
    const ValidateAndReSetPassowrd = async () => {
        setLoginTimer(false);
        if (!validPasswordData()) {
            return;
        }

        const captchaRes = await verifyRecaptcha();
        refreshCaptchaToken();
        if (!captchaRes?.Success) {
            setErrorMsg(captchaRes?.ErrorMessage || t(RECAPTCHA_FAIL));
            return;
        }

        const data = {
            userName: email,
            mobileNo: mobile,
            countryCode: "+91",
            password: 'ss'
        };
        setLoader(true);
        const url = apiUrl.userPwdOtp + "?" + getparamsString(data);
        GetRequest(url)
            .then((res) => {
                if (res.Success) {
                    setLoader(false);
                    setResetting(true);
                    setLoginTimer(true);
                    setResendLoginOTP("disable");
                    setButtonState(3)
                    // setPassword('')
                } else {
                    setLoader(false)
                    setErrorMsg(res.ErrorMessage);
                }
            })
            .catch((err) => { setLoader(false) });
    };
    const ResetPassowrd = async () => {
        if (!ValidNewPassowrdData()) {
            return;
        }

        const captchaRes = await verifyRecaptcha();
        refreshCaptchaToken();
        if (!captchaRes?.Success) {
            setErrorMsg(captchaRes?.ErrorMessage || t(RECAPTCHA_FAIL));
            return;
        }

        const data = {
            userName: email,
            countryCode: "+91",
            mobileNo: mobile,
            password: password,
            otp: loginOTP,
        };
        setLoader(true);
        PostRequest(apiUrl.userResetPwd, data)
            .then((res) => {
                if (res.Success) {
                    setLoader(false)
                    setSuccessMsg(
                        t(PWD_CHNGD_SUCSS)
                    );
                } else {
                    setLoader(false);
                    setErrorMsg(res.ErrorMessage);
                }
            })
            .catch((err) => { setLoader(false) });
    };
    const handleBottomButton = () => {
        if (buttonState === 0) {
            sendSignupOTP();
        }
        if (buttonState === 1) {
            ValidateAndSIgnup();
        }
        if (buttonState === 2) {
            validateAndLogin();
        }
        if (buttonState === 3) {
            ResetPassowrd();
        }
    };
    const resetCountryCode = () => {
        setSearchCountryCodeText("");
        setCheckedCountryCode("");
        setCountryCodeList(countryCodeData);
    };
    const selectCountryCode = () => {
        setCcode(checkedCountryCode);
        setSlider(false);
    };
    // const showCountryCodeOption = () => {
    //     return (
    //         <React.Fragment>
    //             <div
    //                 className="filter--new--transparent"
    //                 style={{ height: "50%" }}
    //                 onClick={() => setSlider(false)}
    //             ></div>
    //             <div className="filter--new--content--wrapper">
    //                 <div className="filter--new--header">
    //                     Select Country Code
    //                     <div
    //                         className="resetbtn"
    //                         onClick={() => {
    //                             resetCountryCode();
    //                         }}
    //                     >
    //                         RESET
    //                     </div>
    //                 </div>
    //                 <div
    //                     className="filter--new--content"
    //                     style={{ padding: "0" }}
    //                 >
    //                     <div className="search--input--wrap">
    //                         <span className="search-icon">
    //                             {renderImg("filter-search")}
    //                         </span>
    //                         <input
    //                             className="search-input"
    //                             type="text"
    //                             placeholder="Search Nationality"
    //                             value={searchCountryCodeText}
    //                             onChange={(e) =>
    //                                 setSearchCountryCodeText(e.target.value)
    //                             }
    //                         />
    //                     </div>
    //                     <div className="bustype--options--wrap">
    //                         {countryCodeList.map((el) => (
    //                             <div
    //                                 key={el.name}
    //                                 className={`buttype--option--wrap ${checkedCountryCode.indexOf(el.name) >
    //                                     -1 &&
    //                                     checkedCountryCode.length ==
    //                                     el.name.length
    //                                     ? "checked"
    //                                     : ""
    //                                     }`}
    //                                 onClick={() => {
    //                                     setCheckedCountryCode(el.name);
    //                                 }}
    //                             >
    //                                 <div className="option--image">
    //                                     <Radio
    //                                         active={
    //                                             checkedCountryCode.indexOf(
    //                                                 el.name
    //                                             ) > -1 &&
    //                                                 checkedCountryCode.length ==
    //                                                 el.name.length
    //                                                 ? true
    //                                                 : false
    //                                         }
    //                                     />
    //                                 </div>
    //                                 <div className="option--text">
    //                                     {el.name}
    //                                 </div>
    //                             </div>
    //                         ))}
    //                     </div>
    //                 </div>
    //             </div>
    //             <Bottom top={false}>
    //                 <div
    //                     className="filter--new--btn"
    //                     style={baseCss.secondaryBackground}
    //                     onClick={() => selectCountryCode()}
    //                 >
    //                     Select Country Code
    //                 </div>
    //             </Bottom>
    //         </React.Fragment>
    //     );
    // };
    const handleRecaptchaChange = (value) => {
        setRecaptchaValue(value);
    };


    const loginFormState = {
        email,
        setEmail,
        cccode,
        setCcode,
        mobile,
        setMobile,
        slider,
        setSlider,
        togglePassword,
        setTogglePassword,
        togglePasswordN,
        setTogglePasswordN,
        togglePasswordR,
        setTogglePasswordR,
        ValidateAndReSetPassowrd,
        password,
        setPassword,
        passwordR,
        setPasswordR,
        tncFlag,
        setTncFLag,
        resettingPassword,
        loginOTP,
        setLoginOtp,
        blockError,
        loginTimer,
        resendLoginOTP,
        setResendLoginOTP,
    };
    const signupFormState = {
        email,
        setEmail,
        cccode,
        setCcode,
        mobile,
        setMobile,
        slider,
        setSlider,
        togglePassword,
        setTogglePassword,
        togglePasswordR,
        setTogglePasswordR,
        password,
        setPassword,
        passwordR,
        setPasswordR,
        tncFlag,
        setTncFLag,
        resettingPassword,
        setResetting,
        signupOTP,
        setSignupOtp,
        name,
        setName,
        signupOtpSent,
        setsignupOtpSent,
        blockError,
        resendSignupOTP,
        setResendSignupOTP,
        signupTimer,
        sendSignupOTP,
        confirmPassword,
        setConfirmPassword
    };

    return (
        <div className="bg-image">
            <HeaderNonSrp />
            <SubHeader />
            {loader && <LoginLoader />}
            <div className="auth-page">
                <div className="auth-page-tabs flex">
                    <div
                        className="radiobtn flex"
                        onClick={() => setLoginTab(0)}
                    >
                        <Radio active={loginTab === 0} />
                        <div className="lgn">{t(LGN)}</div>
                    </div>
                    <div
                        className="radiobtn flex"
                        onClick={() => setLoginTab(1)}
                    >
                        <Radio active={loginTab === 1} />
                        <div className="signup">{t(SOR)}</div>
                    </div>
                </div>
                {loginTab === 0 ? (
                    <LoginForm data={loginFormState} ipAddress={ipAddress} />
                ) : (
                    <SignupForm data={signupFormState} ipAddress={ipAddress} />
                )}


                <div className="flex recaptcha">
                    {/* <div>
                        {ipAddress ? `Your IP Address: ${ipAddress}` : ""}
                    </div> */}
                    {/* <ReCAPTCHA
                            sitekey="YOUR_RECAPTCHA_SITE_KEY" // Replace with your reCAPTCHA site key
                            onChange={handleRecaptchaChange}
                        /> */}

                    <GoogleRecaptchaV3
                        onVerify={onVerify}
                        refreshReCaptcha={refreshReCaptcha}
                    />

                </div>
                <div
                    className="btn payee"
                    style={baseCss.secondaryBackground}
                    onClick={() => handleBottomButton()}
                >
                    {getButtonText()}
                </div>

            </div>
            {/* {slider == "COUNTRY-CODE" && <div className="login--layer"></div>}
            <Slider active={slider} className={"slider-top-transparent"}>
                {slider == "COUNTRY-CODE" && showCountryCodeOption()}
            </Slider> */}
            {errorMsg && (
                <Alert
                    msg={errorMsg}
                    error={true}
                    className="login--alert"
                    close={() => setErrorMsg("")}
                />
            )}
            {successmsg && (
                <Alert
                    msg={successmsg}
                    error={false}
                    className="login--alert"
                    close={() => {
                        setSuccessMsg("");
                    }}
                />
            )}

            {termsFlag && (
                <AlertTerms
                    msg={"hello roushan"}
                    error={false}
                    className="login--alert"
                    setTncFLag={setTncFLag}
                    close={() => {
                        setTermsFlag(false);
                    }}
                />
            )}
            <Footer />
        </div>
    );
};

export default LoginSignUp;
